import * as R from 'ramda';

export default function EditFacilitiesDialogController(
  $rootScope,
  $scope,

  loaderService,
  ssDialogService,
  bcpDataService,
  alerts
) {
  const vm = this;

  vm.newAssessmentFacilities = R.clone(vm.assessmentFacilities);

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleFormSubmit = _handleFormSubmit;

  /** ************************************************
   * Event Handlers
   */


  function _handleCloseDialogClick() {
    _closeDialog();
  }


  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editFacilitiesDialog);
  }

  function _handleFormSubmit() {
    loaderService.showGlobalLoader = true;
    if ($scope.editFacilitiesForm.$valid) {
      bcpDataService.saveFacilities(
        vm.newAssessmentFacilities
      ).then((saveFacilitiesResponse) => {
        angular.extend(vm.assessmentFacilities, saveFacilitiesResponse.data);
        alerts.success('Alternate Facilities have been successfully saved.');
        $rootScope.$broadcast('refreshStatuses');
        loaderService.showGlobalLoader = false;
        if (vm.saveType === 'saveAndClose') {
          _closeDialog();
        }
      });
    }
  }
}

EditFacilitiesDialogController.$inject = [
  '$rootScope',
  '$scope',

  'loaderService',
  'ssDialogService',
  'bcpDataService',
  'alerts',
];
